import RequestSender from './RequestSender.js';

import { useStore } from '@/store/DefaultStore.js';
import UserService from '@/services/UserService.js';
import { useSessionStore } from '@/store/SessionStore.js';

function GetAvailableUsers(data = {}) {
    return RequestSender.Get('user/GetAvailableUsers', data);
}

function GetCurrentUserData(){
    return RequestSender.Get('user/GetCurrentUserData');
}

function GetCurrentUserOrganizationData(){
    return RequestSender.Get('user/GetCurrentUserOrganizationData');
}

function GetUsersMessageData(data){
    return RequestSender.Get('user/GetUsersMessageData', data);
}

function GetUserDetail(PKUser){
    return RequestSender.Get('user/GetUserDetail', PKUser);
}

function RegisterUser(user){
    return RequestSender.Post('user/RegisterUser', user);
}

function EditUser(user){
    return RequestSender.Post('user/EditUser', user);
}

function DisableUser(data){
    return RequestSender.Post('user/DisableUser', data);
}

function EnableUser(data){
    return RequestSender.Post('user/EnableUser', data);
}

function AddUserToOrganization(data){
    return RequestSender.Post('user/AddUserToOrganization', data);
}

function ResendInvitation(data){
    return RequestSender.Post('user/ResendInvitation', data);
}

function CancelInvitation(data){
    return RequestSender.Post('user/CancelInvitation', data);
}

function DeleteUserProfilePicture(){
    return RequestSender.Post('user/DeleteUserProfilePicture');
}

function UpdateUserProfilePicture(data){
    return RequestSender.PostFormData('user/UpdateUserProfilePicture', {}, data);
}

function GetUserOrganizations(){
    return RequestSender.Get('user/GetUserOrganizations');
}

function GetUserExistsByEmail(data){
    return RequestSender.Get('user/GetUserExistsByEmail', data);
}

function GetAllUsers(){
    return RequestSender.Get('user/GetAllUsers');
}

function GetSuperadmins(){
    return RequestSender.Get('user/GetSuperadmins');
}

function AddSuperadmin(data){
    return RequestSender.Post('user/AddSuperadmin', data);
}

function ChangeSuperadminStatus(data){
    return RequestSender.Post('user/ChangeSuperadminStatus', data);

}

function GetUsersForChat(data){
    return RequestSender.Get('user/GetUsersForChat', data);
}

async function SetUserInitialData() {
    const store = useStore();
    const sessionStore = useSessionStore();
  
    try
    {
      store.SetLoader(true);
      store.SetInitialLoading(true);
      let userData, lastOrganization;
  
      await UserService.GetCurrentUserData()
      .then(data => {
        userData = data.UserData;
      })
      .catch(error => {
        if(error.message == 'NO SE HA INGRESADO EL DOBLE FACTOR DE AUTENTICACIÓN'){
            store.RequiresMFA = true;
        }

        throw new Error(error.message ??'OCURRIÓ UN ERROR AL CARGAR LA INFORMACIÓN DEL USUARIO');
      });

      // Sets the current user data
      store.SetLoggedUser(userData);

      // Sets the user Organizations in the list
      store.SetOrganizations(userData.Organizations);

      // Tries to retrieve the last selected organization to set it as current
      lastOrganization = sessionStore.GetCurrentOrganization();
  
      if(lastOrganization != null && userData.Organizations.some(x => x.PKOrganization === lastOrganization)){
        store.CurrentOrganizationPK = lastOrganization;
      }
      // If no last organization, sets the first one in list
      else{
        lastOrganization = userData.Organizations[0].PKOrganization;
        store.CurrentOrganizationPK = lastOrganization;
        sessionStore.SetCurrentOrganization(lastOrganization);
      }

      // Gets the user actions, screens and IsCustomer (For UI only, validates also in server)
      await UserService.GetCurrentUserOrganizationData()
      .then(data => {
        store.SetUserOrganizationData(data);
      })
      .catch(error => {
        throw new Error(error.message ? error.message : 'OCURRIÓ UN ERROR AL CARGAR LAS ACCIONES DEL USUARIO');
      })

      store.SetLoader(false);
    }
    catch(error){
      store.SetLoader(false);
      store.SetInitialLoading(false);
      throw error;
    }
  }

export default {
    GetAvailableUsers, GetCurrentUserData, DisableUser, EnableUser, GetUsersMessageData, GetUserDetail, RegisterUser, EditUser,
    AddUserToOrganization, ResendInvitation, CancelInvitation, DeleteUserProfilePicture, UpdateUserProfilePicture, GetUserOrganizations,
    GetUserExistsByEmail, GetAllUsers, GetSuperadmins, AddSuperadmin, ChangeSuperadminStatus, SetUserInitialData,
    GetUsersForChat, GetCurrentUserOrganizationData
}